import {
	VIEW_PAGE,
	VIEW_BLOG,
	VIEW_BLOG_DATE_LEGACY,
} from '@confluence/named-routes/entry-points/routes.ts';

const ROUTES_WITH_OPTIONAL_SLUG = [VIEW_PAGE, VIEW_BLOG, VIEW_BLOG_DATE_LEGACY];

/**
 * Strips the optional `:contentSlug` segment from a page or blog URL by
 * matching it against known Confluence routes and reconstructing without the slug.
 *
 * Returns the URL unchanged if it does not match any route with an optional slug
 * (e.g. whiteboards, folders).
 */
export const removeContentSlugFromUrl = (url: string): string => {
	for (const route of ROUTES_WITH_OPTIONAL_SLUG) {
		const match = route.match(url);
		if (match) {
			const { contentSlug, ...paramsWithoutSlug } = match.params;
			return route.toUrl(paramsWithoutSlug, {
				query: match.query,
				hash: match.hash,
			});
		}
	}
	return url;
};
